import { Component, Inject } from '@angular/core';
import { faTrashAlt } from '@fortawesome/pro-light-svg-icons';
import { DialogBelonging } from '@costlydeveloper/ngx-awesome-popup';
import { Subscription } from 'rxjs';
import { CartService } from 'src/app/services/cart.service';

@Component({
  selector: 'app-dialog-delete-pass',
  templateUrl: './dialog-delete-pass.component.html',
  styleUrls: ['./dialog-delete-pass.component.scss']
})
export class DialogDeletePassComponent {

  passName: string = '';
  faTrash = faTrashAlt;
  private subscriptions: Subscription = new Subscription();

  constructor(
    private cartService: CartService,
    @Inject('dialogBelonging') public dialogBelonging: DialogBelonging
  ) {}

  ngOnInit() {
    this.passName = this.dialogBelonging.customData?.passName || 'este abono';

    this.subscriptions.add(
      this.dialogBelonging.eventsController.onButtonClick$.subscribe((_Button) => {
        if (_Button.ID === 'confirm') {
          // El back elimina el abono completo (pass_group) con una sola línea
          const cartLine = this.dialogBelonging.customData?.cartLine;
          const allLines: any[] = this.cartService.getCartState()?.cart_lines || [];
          const passLines = cartLine?.pass_group
            ? allLines.filter((l: any) => l.pass_group === cartLine.pass_group)
            : [cartLine];
          const bookings = passLines.reduce(
            (seats: any[], line: any) => seats.concat((line.bookings || []).map((b: any) => b.id_seat)),
            []
          );

          this.cartService.deleteItemToCart(cartLine.id, bookings).subscribe({
            next: () => {
              this.cartService.getCart().subscribe();
            },
            error: (err) => {
              console.error('[DialogDeletePass] Error:', err);
              this.cartService.getCart().subscribe();
            }
          });

          this.dialogBelonging.eventsController.close();
        } else if (_Button.ID === 'cancel') {
          this.dialogBelonging.eventsController.close();
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
